import { createFileRoute } from '@tanstack/react-router'
import { MyCvPage } from '@/pages/profile/my-cv/ui/MyCvPage'

export const Route = createFileRoute('/my-cv')({ component: MyCvPage })
